import { NSCard, NSNavTabs } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { PRO_FORMA_TABLE_NAV, RETURNS_AND_WATERFALL_TABS } from 'views/ProFormaTable/constants';
import classNames from 'classnames';
import Returns from './Returns/Returns';
import WaterfallAnalysis from './WaterfallAnalysis/WaterfallAnalysis';

export interface IReturnsAndWaterfallProps {
    navigateToSection: (sideNavName: string, tabName?: string) => void;
    currentSection?: string;
    currentTab?: string;
    hasWriteAccessToProForma: boolean;
}

const ReturnsAndWaterfall = ({
    navigateToSection, currentSection, currentTab, hasWriteAccessToProForma,
}: IReturnsAndWaterfallProps) => (
    <>
        <NSNavTabs
            containerClassName="px-0 w-50"
            navItems={Object.entries(RETURNS_AND_WATERFALL_TABS).map(([key, value], index) => ({
                callback: e => {
                    e.preventDefault();
                    navigateToSection(currentSection || PRO_FORMA_TABLE_NAV.RETURNS_AND_WATERFALL.name, value);
                },
                className: classNames('text-nowrap', {
                    'mr-1': index !== Object.keys(RETURNS_AND_WATERFALL_TABS).length - 1,
                    'heap-deal-pro-forma-click-returns': currentTab === RETURNS_AND_WATERFALL_TABS.RETURNS,
                    'heap-deal-pro-forma-click-waterfall-analysis': currentTab === RETURNS_AND_WATERFALL_TABS.WATERFALL_ANALYSIS,
                }),
                name: value,
                isActive: currentTab === value,
                id: `returns-waterfall-tab-${index}`,
            }))}
        />
        <hr className="my-0" />
        <NSCard className="p-2">
            <RenderIf isTrue={currentTab === RETURNS_AND_WATERFALL_TABS.RETURNS}>
                <Returns />
            </RenderIf>
            <RenderIf isTrue={currentTab === RETURNS_AND_WATERFALL_TABS.WATERFALL_ANALYSIS}>
                <WaterfallAnalysis hasWriteAccessToProForma={hasWriteAccessToProForma} />
            </RenderIf>
        </NSCard>
    </>
);

export default ReturnsAndWaterfall;
